import ComponentGuard from '../ComponentGuard';
import { UserTypeEnum } from '@/models/User';
import RowListTextDisplay from './RowListTextDisplay';
import { ShortEnrollment } from '@/models/Student';

type KlassesDisplayProps = {
  klasses?: ShortEnrollment[];
  width?: number;
};

export default function KlassesDisplay({
  klasses = [],
  width,
}: KlassesDisplayProps) {
  return (
    <ComponentGuard roles={[UserTypeEnum.TEACHER]}>
      <RowListTextDisplay items={klasses} hasCopyButton width={width} />
    </ComponentGuard>
  );
}
